
import { Language } from '@/types/language';
import { en } from './languages/en';
import { es } from './languages/es';
import { fr } from './languages/fr';
import { de } from './languages/de';
import { it } from './languages/it';
import { zh } from './languages/zh';
import { ja } from './languages/ja';
import { ko } from './languages/ko';
import { ar } from './languages/ar';
import { fi } from './languages/fi';
import { he } from './languages/he';

export const translations: Record<Language, Record<string, string>> = {
  en,
  es,
  fr,
  de,
  it,
  zh,
  ja,
  ko,
  ar,
  fi,
  he,
};
